import { Component, OnInit, Input, ElementRef } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';

@Component({
  selector: '[cmGridCell]',
  templateUrl: './grid-cell.component.html',
  styleUrls: ['./grid-cell.component.scss'],
  animations: [
    trigger('focusedTrigger', [
      state(
        'true',
        style({
          transform: 'scale(1.5)',
          transformOrigin: '50% 50%',
        })
      ),
      state(
        'false',
        style({
          transform: 'scale(1)',
          transformOrigin: '50% 50%',
        })
      ),
      transition('* <=> *', animate('300ms ease-out')),
    ]),
  ],
})
export class GridCellComponent implements OnInit {
  @Input() image: any;
  active: boolean = false;

  constructor(private el: ElementRef) {}

  ngOnInit() {}

  ngDoCheck() {
    if (this.el.nativeElement.children[0].classList.contains('active')) {
      this.active = true;
    } else {
      this.active = false;
    }
  }
}
